module.exports = __webpack_public_path__ + "img/face-pouting.f6c0efed.svg";